export default __webpack_public_path__ + "images/dce5368a871ed36df447f761791a6e66-public_speaker.jpg";